import React, { useContext } from 'react';
import { Icon, Label } from 'semantic-ui-react';
import { uniqueKey } from '../../../global/common/keys';
import { CreateGolfContext } from '../create/CreateGolf';
import { GolfParentContext } from '../cnr/contexts/GolfParentContext';

const GolferTeamSelect = (props) => {

  const { golfer, rowIndex } = props
  const { key: key_player, teamNumber, lastName, firstName, tournamentHandicapIndex } = golfer ?? {}

  // golfParentContext 
  const golfParentContext = useContext(GolfParentContext)
  const { golfParent_contexts } = golfParentContext ?? {}
  const { states, handlers } = golfParent_contexts ?? {}
  const { golfTournament_state } = states ?? {}
  const { golfTournament_handlers } = handlers ?? {}

  // createGolfContext
  const createGolfContext = useContext(CreateGolfContext);
  const { golfEvent_handlers, golfCreate_state, golfCreate_handlers } = createGolfContext ? createGolfContext : {}
  const { tournamentDetails, golfStyles: golfStyles_create } = golfCreate_state ? golfCreate_state : {}
  const { golfers: golfers_tournament } = tournamentDetails ? tournamentDetails : {}

  // golfTournamentContext 
  const { golfStyles } = golfTournament_state ?? {}
  const _golfStyles = golfStyles_create ? golfStyles_create : golfStyles

  const { golfTeam1Style, golfTeam2Style, neutralStyle } = _golfStyles ? _golfStyles : {}

  const handleClick = (teamIndex) => {
    if (golfEvent_handlers) {
      const _golfers_tournament = { ...golfers_tournament }
      const { firstName, lastName, _itemKey, tournamentHandicapIndex } = golfer
      const _golfer = { key: _itemKey, golferKey: _itemKey, _itemKey, teamNumber: teamIndex, firstName, lastName, tournamentHandicapIndex }
      _golfers_tournament[_itemKey] = _golfer
      tournamentDetails.golfers = _golfers_tournament
      golfCreate_handlers.handleAmmend_tournamentDetails(tournamentDetails, rowIndex)
    } else {
      golfTournament_handlers.handleChange_golferTeam(golfer, teamIndex, rowIndex)
    }
  }

  const nameDiv = (iconName) => <div className={'player-split'}>
    <div><Icon name={iconName} /></div>
    <div>{firstName}</div>
    <div>{lastName}</div>
    <div>{tournamentHandicapIndex}</div>
  </div>

  const playerContent = (team) => {

    // let name = 'select'
    let iconName = 'check'
    let sty = neutralStyle
    let cn;

    switch (team) {
      case 1:
        switch (teamNumber) {
          case 1:
            iconName = 'check circle outline'
            sty = golfTeam1Style
            cn = 'gts-1' // 
            break;
          default:
          // nothing
        }
        break;
      case 2:
        switch (teamNumber) {
          case 2:
            iconName = 'check circle outline'
            sty = golfTeam2Style
            cn = 'gts-2' // 
            break;
          default:
          // nothing
        }
        break;
      default:
        iconName = 'ban'
        sty = neutralStyle
        break;
      // nothing
    }
    return <Label style={sty} className={cn} onClick={(e) => { handleClick(team) }}  >{nameDiv(iconName)}</Label>
  }

  const golferTeamSelect = () => {
    return <div className={'athlete-team-select'} key={key_player} >
      <div key={uniqueKey('gts', 'd', 1)} className={'athlete-team-1'}>{playerContent(1)}</div>
      <div key={uniqueKey('gts', 'd', 2)} className={'athlete-team-0'}>{playerContent(0)}</div>
      <div key={uniqueKey('gts', 'd', 3)} className={'athlete-team-2'}>{playerContent(2)}</div>
    </div >
  }

  return golferTeamSelect()

}

export default GolferTeamSelect